<template>
  <div class="frame-content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "FrameContent"
};
</script>

<style scoped>
.frame-content {
  padding: 2rem 0;
  height: 100%;
  width: 100%;
}
</style>